import { makeStyles } from 'tss-react/mui';
import { MODAL_BODY_PADDING } from './modal.constants';

export const useModalStyles = makeStyles({ name: 'Modal' })((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: `calc(100% - ${theme.spacing(8)})`,
    maxHeight: `calc(100% - ${theme.spacing(8)})`,
    margin: theme.spacing(4),
    borderRadius: theme.shape.borderRadius2xl,
    backgroundColor: theme.palette.background.paper,
    [theme.breakpoints.down('sm')]: {
      maxWidth: `calc(100% - ${theme.spacing(4)})`,
      margin: theme.spacing(2),
    },
  },
  drawerContainer: {
    alignItems: 'flex-end',
  },
  fullScreenPaper: {
    margin: 0,
    width: '100%',
    maxWidth: '100%',
    height: '100%',
    maxHeight: '100%',
    borderRadius: 0,
  },
  drawerPaper: {
    margin: 0,
    width: '100%',
    maxWidth: '100%',
    borderTopLeftRadius: theme.shape.borderRadius2xl,
    borderTopRightRadius: theme.shape.borderRadius2xl,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexShrink: 0,
    padding: theme.spacing(1.5, MODAL_BODY_PADDING, 1, MODAL_BODY_PADDING),
  },
  headerTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flex: 1,
    minWidth: 0,
  },
  headerAction: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexShrink: 0,
  },
  headerBottom: {
    flexShrink: 0,
    padding: theme.spacing(0, 2, 0.5),
  },
  registrationHeaderBottom: {
    '&:has([role="tablist"])': {
      paddingBottom: theme.spacing(2.5),
    },
  },
  body: {
    fontFamily: theme.typography.body1.fontFamily,
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.body1.fontWeight,
    lineHeight: theme.typography.body1.lineHeight,
    letterSpacing: theme.typography.body1.letterSpacing,
    flex: '1 1 auto',
    overflowY: 'auto',
    padding: theme.spacing(1, MODAL_BODY_PADDING, 2, MODAL_BODY_PADDING),
  },
  bodyWithoutFooter: {
    paddingBottom: 0,
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexShrink: 0,
    padding: theme.spacing(1.5, MODAL_BODY_PADDING),
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  footerTertiary: {
    marginRight: 'auto',
  },
  footerActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginLeft: 'auto',
  },
}));
